// Análise de endereço (antifraude) do pedido de venda de 1ª compra.
// Regras: ERPApi/docs/funcionalidades/analise-de-endereco.md.

export const AddressReviewStatus = {
  Pending: 1,
  Approved: 2,
  Rejected: 3,
} as const;

export interface OrderAddressReview {
  order_id: number;
  status: number;
  is_mandatory: boolean;
  address_text: string;
  pano_id?: string;
  pano_date?: string;
  lookup_status: string;
  lookup_error?: string;
  looked_up_at?: string;
  reviewed_by?: string;
  reviewed_at?: string;
  review_note?: string;
  created_at?: string;
  created_by: string;
  /** Foto/print da portaria ou fachada anexado por quem analisa (condomínio fechado). */
  has_photo?: boolean;
  photo_uploaded_by?: string;
  photo_uploaded_at?: string;
}

export interface OrderAddressReviewView {
  order_id: number;
  is_first_purchase: boolean;
  current_address: string;
  review?: OrderAddressReview | null;
  blocking: boolean;
  block_reason?: string;
  address_changed: boolean;
  maps_url?: string;
  inherited_from_order_id?: number;
}

export const addressReviewStatusLabel = (status?: number): string => {
  switch (status) {
    case AddressReviewStatus.Pending:
      return 'Pendente';
    case AddressReviewStatus.Approved:
      return 'Aprovada';
    case AddressReviewStatus.Rejected:
      return 'Reprovada';
    default:
      return 'Sem análise';
  }
};

export const lookupStatusLabel = (status?: string): string => {
  switch (status) {
    case undefined:
    case '':
      return '—';
    case 'NOT_FETCHED':
      return 'Ainda não consultada';
    case 'OK':
      return 'Imagem encontrada';
    case 'ZERO_RESULTS':
    case 'NOT_FOUND':
      return 'Sem imagem no Street View';
    case 'NO_ADDRESS':
      return 'Pedido sem endereço de entrega';
    case 'REQUEST_DENIED':
      return 'Consulta recusada pelo Google';
    default:
      return `Falha na consulta (${status})`;
  }
};

/** Mínimo de caracteres da observação quando ela é obrigatória (igual ao backend). */
export const ADDRESS_REVIEW_MIN_NOTE = 10;

/** Limite da foto anexada no backend (a tela comprime antes, então raramente chega perto). */
export const ADDRESS_REVIEW_MAX_PHOTO_BYTES = 10 * 1024 * 1024;

/**
 * A observação é obrigatória para reprovar e, para aprovar, só quando não há evidência:
 * nem imagem do Street View nem foto anexada (mesma regra do backend, RN-AEN-04).
 */
export const addressReviewNoteRequired = (approve: boolean, hasImagery: boolean, hasPhoto: boolean): boolean =>
  !approve || (!hasImagery && !hasPhoto);

/** Primeiro arquivo de imagem de uma colagem (Ctrl+V), de um arrasto ou do seletor de arquivo. */
export const firstImageFile = (files: ArrayLike<File> | null | undefined): File | null => {
  if (!files) return null;
  for (let i = 0; i < files.length; i++) {
    if (files[i]?.type?.startsWith('image/')) return files[i];
  }
  return null;
};
